export const globalConfig = defineStore('global', {
  state: () => ({
    packs: [],
    faqs: [],
    location: {},
    geo: {},
  }),
  actions: {
    setPacks(packs) {
      this.packs = packs;
    },
    setFaqs(faqs) {
      this.faqs = faqs;
    },
    setLocation(location) {
      this.location = location;
    },
    setLatLng({ lat, lng }) {
      this.location.loc = [lat, lng].join(',');
    },
    setLocationError(error) {
      this.location.error = error;
    },
    setGeo(location) {
      this.geo = {
        ...location,
        loc: [location.lat, location.lng].join(',')
      };
    },
    clearLocationError() {
      this.location.error = null;
    }
  },
  getters: {
    hasPacks: (state) => state?.packs?.length > 0
  },
  persist: {
    pick: ['faqs', 'geo'],
    storage: piniaPluginPersistedstate.localStorage()
  }
});
